import i18n from 'i18next';

import common_ru from "./locale/ru/common.json";
import common_ua from "./locale/ua/common.json";
import common_en from "./locale/en/common.json";

i18n.init({
    interpolation: { escapeValue: false },  // React already does escaping
    lng: 'ru',                              // language to use
    resources: {
        ru: {
            common: common_ru              // 'common' is our custom namespace
        },
        ua: {
            common: common_ua
        },
        en: {
            common: common_en
        },
    },
});

export default i18n;
